export default class AiPromptEvents {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  list(filter) {
    var event = AiPromptEvents.List.Request(filter);
    return this.eventsDomain.initRequest(event);
  }

  static List = {
    Names: {
      Request: 'AiPromptListRequestEvent',
      Response: 'AiPromptListResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: '',
      },
    },

    Request: function (filter) {
      var event = {
        handler: "AiPromptListRequestEvent",
        eventName: "AiPromptListRequestEvent",
        filter: filter.data,
      };
      return event;
    },
  }
}
